import { Component, OnInit, OnDestroy } from '@angular/core';
import { IffShipmentDetailsService } from 'src/app/services/iff-shipment-details/iff-shipment-details.service';
import { ActivatedRoute } from '@angular/router';
import {GridOptions, ColGroupDef, ColDef, GridApi} from 'ag-grid-community';
import { BehaviorSubject } from 'rxjs';
import { takeWhile, tap } from 'rxjs/operators';
import { IffShipmentSummaryService } from 'src/app/services/iff-shipment-summary/iff-shipment-summary.service';

@Component({
    selector: 'app-hhg-iff-detail',
    templateUrl: './hhg-iff-detail.component.html',
    styleUrls: ['./hhg-iff-detail.component.css'],
    standalone: false
})
export class HhgIffDetailComponent implements OnInit, OnDestroy {

  private observer$ = new BehaviorSubject(true);
  hhgIFFShipmentDetailResults$ = this.iffShipmentDetailsService.hhgIFFShipmentDetailResults$;
  selectedIFFShipmentSummary$ =  this.iffShipmentSummaryService.selectedHHGShipmentSummary$;
  hhgIFFShipmentDetailGridOptions: GridOptions = this.initializeGridOptions();
  private gridApi!: GridApi<any>;

  constructor(private route: ActivatedRoute, private iffShipmentSummaryService: IffShipmentSummaryService,
      private iffShipmentDetailsService: IffShipmentDetailsService) { }

  ngOnInit() {
    this.route.queryParams.subscribe(
      params => {
        this.iffShipmentDetailsService.updateHHGIffShipmentDetailRequest(params['iffMasterId']);
      });
  }

  private initializeGridOptions() {
    return <GridOptions>{
      columnDefs: this.getHHGIffShipmentDetailsColumnDefs(),
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: false
        }
      },
      headerHeight: 50,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      domLayout: 'autoHeight',
      suppressDragLeaveHidesColumns: true,
      onGridReady: params => {
        this.gridApi = params.api;
        params.api.sizeColumnsToFit();
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
      overlayNoRowsTemplate:
        '<span>No results found. Please adjust your filters.</span>'
    };
  }

  getHHGIffShipmentDetailsColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
      {
        headerName: 'SCAC Code',
        field: 'scac'
      },
      {
        headerName: 'SCAC ',
        field: 'scacName'
      },
      {
        headerName: 'FAIC ',
        field: 'faicCode'
      },
      {
        headerName: 'Agency Bureau Name',
        field: 'agencyBureauName'
      },
      {
        headerName: 'Pro Bill Number',
        field: 'proBillNumber'
      },
      {
        headerName: 'BOL',
        field: 'bolNumber'
      },
      {
        headerName: 'GBL/CBL',
        field: 'gblcbl'
      },
      {
        headerName: 'Move Type',
        field: 'moveType'
      },
      {
        headerName: 'Pickup Date',
        field: 'pickupDate'
      },
      {
        headerName: 'Delivery Date',
        field: 'deliveryDate'
      },
      {
        headerName: 'Origin',
        field: 'originStateCode'
      },
      {
        headerName: 'Destination',
        field: 'destinationStateCode'
      },
      {
        headerName: 'Last Name',
        field: 'employeeLastName'
      },
      {
        headerName: 'Weight',
        field: 'weight'
      },
      {
        headerName: 'Miles',
        field: 'miles'
      },
      {
        headerName: 'Discount',
        field: 'discount'
      },
      {
        headerName: 'Gross Amount',
        field: 'grossAmount'
      },
      {
        headerName: 'Net Amount',
        field: 'netAmount'
      },
      {
        headerName: 'Pass Thr amt',
        field: 'passThruAmount'
      },
      {
        headerName: 'Total AF',
        field: 'totalIFF'
      }
    ];
  }

  onExport() {
    const date = new Date();
    const params = {
      fileName: 'HHG' + '-iff-detail-rates-report-' + date + '.csv',
      allColumns: true,
      columnSeparator: ','
    };
    this.gridApi.exportDataAsCsv(params);
  }
  ngOnDestroy() {
    this.observer$.next(false);
  }
}
